import React, { useState } from 'react';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputAdornment from '@material-ui/core/InputAdornment';

const CustomSelect = ({ id, label, required, icon, data, handleChange }) => {
    const [value, setValue] = useState('');
    
    return (
        <FormControl
            margin="dense"
            placeholder={label}
            fullWidth
            required={required}
        >
            <InputLabel>{label}</InputLabel>
            <Select
                id={id}
                label={label}
                value={value}
                startAdornment={
                    icon ?
                        <InputAdornment position="start">
                            {icon}
                        </InputAdornment>
                        : false
                }
                onChange={(event) => {
                    setValue(event.target.value);
                    if (handleChange !== undefined)
                        handleChange();
                }}
            >
                {
                    data ?
                        data.map((item, index) =>
                            <MenuItem key={index} value={item.key}>{item.value}</MenuItem>
                        ) :
                        null
                }
            </Select>
        </FormControl>
    )
};
export default CustomSelect;